import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';

@Injectable()
export class CataloguesService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/courses/catalogues');
  }

  /**
   * Updates a catalog item.
   *
   * @param catalogId             The catalog's id.
   * @param data                  Catalog item's data to update, including courseId.
   * @param accessChangeConfirmed Whether course access modification was confirmed.
   * @param lang                  Language in which itineraries affected by course access change
   *                              titles will be returned.
   */
  public async updateCatalogItem(catalogId: string, data: any, accessChangeConfirmed?: boolean, lang: string = 'en') {
    return super.putRequest(
      `${this.baseUrl}/${catalogId}/item?accessChangeConfirmed=${accessChangeConfirmed}&lang=${lang}`,
      data,
      this.getRequestOptions()
    );
  }

  updateCatalogue(catalogueId: string, data: any) {
    const url = `${this.baseUrl}/${catalogueId}`;
    return super.putRequest(url, data, this.getRequestOptions());
  }
}
